import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "relative items-center py-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_confirmation_modal = _resolveComponent("confirmation-modal")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_form_divider = _resolveComponent("form-divider")!
  const _component_button_wrapper = _resolveComponent("button-wrapper")!
  const _component_form_wrapper = _resolveComponent("form-wrapper")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    "have-modal": true,
    "is-displayed": _ctx.isChangeOwnershipOpened,
    "is-select-modal": true,
    "no-padding": true,
    title: "Change asset owner",
    onToggleModal: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('toggle-modal')))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_confirmation_modal, {
        "delete-text": "changeOwner",
        "is-confirmation-modal-opened": _ctx.isConfirmationModalOpened,
        onConfirmAction: _ctx.handleSubmit,
        onCloseConfirmationModal: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isConfirmationModalOpened = false)),
        onToggleModal: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isConfirmationModalOpened = false))
      }, null, 8, ["is-confirmation-modal-opened", "onConfirmAction"]),
      _createVNode(_component_form_wrapper, {
        "is-form-in-modal": true,
        "is-loading": _ctx.isLoading,
        "need-for-scroll": true
      }, {
        default: _withCtx(() => [
          _createElementVNode("form", {
            onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.isConfirmationModalOpened = true), ["prevent"]))
          }, [
            _createVNode(_component_form_divider, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _cache[5] || (_cache[5] = _createElementVNode("label", { class: "whitespace-nowrap text-sm font-medium not-italic text-gray-800" }, "User", -1)),
                  _createVNode(_component_v_select, {
                    modelValue: _ctx.selectedUserId,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedUserId) = $event)),
                    class: _normalizeClass(`mt-1`),
                    options: _ctx.users,
                    reduce: (user) => user.id,
                    label: "email",
                    clearable: false
                  }, null, 8, ["modelValue", "options", "reduce"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_button_wrapper, { "is-submit-loading": _ctx.isSubmitLoading }, null, 8, ["is-submit-loading"])
          ], 32)
        ]),
        _: 1
      }, 8, ["is-loading"])
    ]),
    _: 1
  }, 8, ["is-displayed"]))
}